export var variants = {sansCondA:'$_8CSgH',sansCondACaps:'$_3bPMH',sansCondB:'$_2z_Qv',sansCondC:'$_3Pdpx'};